module.exports = __webpack_public_path__ + "static/media/ipr.ae15a9e6.svg";